var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{staticClass:"btn",class:_vm.imageStyle,attrs:{"src":"/scales.svg","width":"20px","alt":"Scales Icon"},on:{"mouseover":_vm.onMouseOver,"mouseleave":_vm.onMouseLeave,"click":_vm.openAlertModal}})])
}
var staticRenderFns = []

export { render, staticRenderFns }